"use client";

import { useGSAP } from "@gsap/react";
import ClipPathTitle from "../components/ClipPathTitle";
import gsap from "gsap";
import { SplitText } from "gsap/all";
import VideoPinSection from "../components/VideoPinSection";
const BenefitSection = () => {
  useGSAP(() => {
    const revealTl = gsap.timeline({
      delay: 1,
      scrollTrigger: {
        trigger: ".benefit-section",
        start: "top 60%",
        end: "top top",
        scrub: 1.5,
      },
    });

    revealTl
      .to(".benefit-section .first-title", {
        duration: 1,
        opacity: 1,
        clipPath: "polygon(0% 0%, 100% 0, 100% 100%, 0% 100%)",
        ease: "circ.out",
      })
      .to(".benefit-section .second-title", {
        duration: 1,
        opacity: 1,
        clipPath: "polygon(0% 0%, 100% 0, 100% 100%, 0% 100%)",
        ease: "circ.out",
      })
      .to(".benefit-section .third-title", {
        duration: 1,
        opacity: 1,
        clipPath: "polygon(0% 0%, 100% 0, 100% 100%, 0% 100%)",
        ease: "circ.out",
      })
      .to(".benefit-section .fourth-title", {
        duration: 1,
        opacity: 1,
        clipPath: "polygon(0% 0%, 100% 0, 100% 100%, 0% 100%)",
        ease: "circ.out",
      });

    const moreTextSplit = SplitText.create(".more-text", {
      type: "chars",
    });

    gsap.from(moreTextSplit.chars, {
      y: 100,
      opacity: 0,
      rotate: 20,
      stagger: 0.05,
      duration: 1,
      ease: "elastic.out(1, 0.3)",
      scrollTrigger: {
        trigger: ".more-text",
        start: "top 95%",
      },
    });

    return () => {
      moreTextSplit.revert();
    };
  });

  const features = [
    {
      key: "inhouse",
      title: "In House Manufacturing",
      className: "first-title",
      colors: { color: "#faeade", bg: "#c88e64", border: "#222123" },
    },
    {
      key: "panindia",
      title: "Pan India Delivery / Support",
      className: "second-title",
      colors: { color: "#222123", bg: "#faeade", border: "#222123" },
    },
    {
      key: "crew",
      title: "Kickass Crew",
      className: "third-title",
      colors: { color: "#faeade", bg: "#7F3B2D", border: "#222123" },
    },
    {
      key: "innovations",
      title: "Innovations PRO MAX",
      className: "fourth-title",
      colors: { color: "#2E2D2F", bg: "#FED775", border: "#222123" },
    },
    {
      key: "ecosystem",
      title: "India’s first Kunafa Ecosystem",
      className: "fifth-title",
      colors: { color: "#faeade", bg: "#2E2D2F", border: "#222123" },
    },
  ];

  return (
    <section id="benefits" className="benefit-section bg-[#222123]">
      <div className="container bg-[#222123] mx-auto pt-20 relative">
        <div className="col-center">
          <p className="text-white">
            Unlock the Advantages: <br />
            Explore the Key Benefits of Choosing Kunafa World
          </p>

          <div className="mt-10 md:mt-20 col-center relative w-full md:gap-4 px-4 md:px-0">
            {features.map((f) => (
              <div
                key={f.key}
                className="w-full flex flex-col gap-6 items-center"
              >
                <div className="scale-110 md:scale-145">
                  <ClipPathTitle
                    title={f.title}
                    color={f.colors.color}
                    bg={f.colors.bg}
                    className={f.className}
                    borderColor={f.colors.border}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="md:-mt-32 mt-10 relative z-20">
            <p className="more-text text-white font-bold text-2xl tracking-widest uppercase">
              And much more ...
            </p>
          </div>
        </div>
      </div>

      <div className="relative overlay-box">
        <VideoPinSection />
      </div>
    </section>
  );
};

export default BenefitSection;
